import React from "react";
import SegmentAnalytics from '../../../services/segmentAnalytics'
//IMAGES
import CotalityLogo from '../../../image/CotalityLogo-footer.svg'

import './footer.css'

export default function Footer() {

  const segmentAnalytics = new SegmentAnalytics()

  function redirectToURL(link, pageName) {
    segmentAnalytics.trackCompanyInfo(pageName);
    window.open(link, '_blank', 'noopener noreferrer');
  }

  return (
    <footer className="footer" id="footer">
      <div className="container padding-30-0">
        <div className="footer-row row">
          <div id="footer-container" className="footer-column">
            <div className="row footer-terms margin-10">
              <p className="no-margin footer-links">
                &copy; 2026 RP Data Pty Ltd t/a Cotality <br className="line-break-768" />(ABN 67 087 759 171).&nbsp;
                <br className="line-break-992 line-break-574" />
                All rights reserved.
              </p>
              <p className="no-margin footer-links">
                <a
                  className="footer-link"
                  id="privacy-policy"
                  onClick={() => {redirectToURL("https://www.cotality.com/au/legal/privacy", "Privacy Policy")}}
                >
                  Privacy Policy
                </a>
                <br className="line-break-464" />
                <span className="divider-">|</span>
                <a
                  className="footer-link"
                  id="general-terms"
                  onClick={() => {redirectToURL("https://www.cotality.com/au/legal/terms-conditions", "General Terms & Conditions")}}
                >
                  General Terms & Conditions
                </a>
                <br className="line-break-768 line-break-465" />
                <span className="divider-768 divider-465">|</span>
                <a
                  className="footer-link"
                  id="website-terms"
                  onClick={() => {redirectToURL("https://www.cotality.com/au/legal/website-terms-of-use", "Website Terms of Use")}}
                >
                  Website Terms of Use
                </a>
                <br className="line-break-992 line-break-464" />
                <span className="divider-992">|</span>
                <a
                  className="footer-link"
                  id="data-code-of-conduct"
                  onClick={() => {redirectToURL("https://www.cotality.com/au/legal/data-code-of-conduct", "Data Code of Conduct")}}
                >
                  Data Code of Conduct
                </a>
                <br className="line-break-465 line-break-464" />
                <span className="divider-465">|</span>
                <a
                  className="footer-link"
                  id="disclaimer"
                  onClick={() => {redirectToURL("https://www.cotality.com/au/legal/disclaimers", "Disclaimer")}}
                >
                  Disclaimer
                </a>
              </p>
            </div>
          </div>
          <div id="footer-logo-column" className="footer-column">
            <img src={CotalityLogo} alt="Core Logic" id="footer-logo"/>
          </div>
        </div>
      </div>
    </footer>
  )
}
